// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"438":"90f79306","684":"28fbcd16","702":"176ad8a1","706":"3b71ec4c","873":"63377136","976":"64d9045d","981":"affb31dd"}[chunkId] + ".chunk.js";
};